import React from 'react'
import { ProductsData } from '../data/products-data'
import { Link } from 'react-router-dom'
import Slider from '../components/Slider'
// import ProductItem from '../components/ProductItem'
import { motion, AnimatePresence } from 'framer-motion';  
import { containerVariants, itemVariants } from '../data/animations'; 
const Anasayfa = () => {




  return (
    <div className='w-full '>
      <div className=' w-full  mb-16'>

        <Slider />

      </div>

      <div className=' grid grid-cols-10'>





        <motion.div

          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          exit="exit"
          className=' col-start-2  col-span-8   grid  grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 pb-20'>



          {
            ProductsData.map((item, index) => {
              return (

                <motion.div
                  custom={index}
                  key={index}
                  className="text-black  bg-white"
                  variants={itemVariants}
                >
                  <Link to={`/products/${item.categoryUrl}`} className=' bg-red-500'>
                    <div className="!overflow-hidden h-full group shadow-sm hover:shadow transition-all duration-300 hover:scale-105 bg-white">
                      <div className="aspect-square w-full bg-white !overflow-hidden">
                        <img
                          src={`/images/products/${item.categoryUrl}/main.jpg`}
                          className="aspect-square h-full w-full object-cover cursor-pointer group-hover:scale-105 transition-all duration-300"

                          alt=""
                        />
                      </div>


                      <div className="px-5 pb-5 flex flex-col justify-between flex-1 space-y-5 ">
                        <div className="pt-5">
                          <h6 className="font-medium text-2xl text-turkuaz-blue">
                            {item.categoryName}
                          </h6>
                        </div>
                        <div className="flex space-x-2">
                          <h2 className="text-xs">DAHA FAZLASI İÇİN</h2>
                          <img
                            src="/images/right-hook.svg"
                            alt="Arrow icon"
                            className="group-hover:translate-x-2 transition-all duration-300"
                          />
                        </div>
                      </div>
                    </div>

                  </Link>
                </motion.div>
              )
            })
          }




        </motion.div>









      </div>
    </div>
  )
}

export default Anasayfa
